import List from '../components/list.js';
import { useState, useContext, useEffect } from 'react';
import Context from '../components/context.js';
import { Link } from 'react-router-dom';
import axios from 'axios';

const HostList = () => {
    const [hosts, setHosts] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(true);
    const setContext = useContext(Context)[1];
    const [checks, setChecks] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);
    setContext('Hosts');
    const headings = [
        { key: 'id', name: 'ID' },
        { key: 'name', name: 'Name', link: true, linkKey: 'id' },
        { key: 'episodes', name: 'Episodes' },
        { key: 'nextEvent', name: 'Next Event' },
    ]
    const loadHosts = (page) => {
        setLoading(true);
        setHosts([]);
        axios.post(process.env.REACT_APP_API_URL + 'speaker', {
            page: page,
            search: search
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                let now = new Date();
                setTotalRecords(r.data.total);
                setHosts(r.data.results.map(res => {
                    let nextEvent = 'No Events';
                    if (res.events?.length > 0) {
                        let eventDates = res.events.map(e => new Date(e.datetime));
                        let ned = eventDates.sort((a, b) => new Date(a) - new Date(b)).find(d => new Date(d) > now);
                        if (ned) {
                            nextEvent = ned.toLocaleDateString();
                        }
                    }
                    let name = res.lastName ? res.firstName + ' ' + res.lastName : res.firstName;
                    res.name = name;
                    res.nextEvent = nextEvent;
                    res.episodes = res.episodeCount || 0;
                    return res;
                }));
            }
        });
    }
    const deleteHosts = () => {
        let toDelete = checks.reduce((acc, cur, i) => {
            if (cur) {
                acc.ids.push(hosts[i].id);
                acc.urls.push(hosts[i].imageUrl);
            }
            return acc
        }, { ids: [], urls: [] });
        if (toDelete.ids.length === 0)
            return;
        axios.post(process.env.REACT_APP_API_URL + 'host/delete', {
            ids: JSON.stringify(toDelete.ids),
            urls: JSON.stringify(toDelete.urls)
        }).then(r => {
            setLoading(false);
            if (r?.data?.status === 'Success') {
                loadHosts(currentPage);
                setChecks(Array.apply(null, Array(hosts?.length)).map(() => false));
            }
        });
    }
    useEffect(() => {
        loadHosts(0);
    }, []);
    useEffect(() => {
        setChecks(Array.apply(null, Array(hosts?.length)).map(() => false));
    }, [hosts]);
    const pageSize = 20;
    var pages = [];
    for (var i = Math.max(0, currentPage - 3); i < Math.min(currentPage + 4, Math.ceil(totalRecords / pageSize)); i++) {
        pages.push(i);
    }
    return (
        <main>
            <div className="container w-100">
                <div className="form mb-10">
                    <div className="w-100 f-row gap-10">
                        <Link to="/host" className="btn btn-green">Add Host</Link>
                    </div>
                    <div className="mw-300 w-100 gap-10 f-row">
                        <button className="link-styles" onClick={deleteHosts}>Delete</button>
                    </div>
                    <div className="mw-300 w-100 ml-auto gap-10 f-row f-end">
                        <input type="search" placeholder="Search Hosts" value={search} onChange={(e) => setSearch(e.target.value)} />
                        <button className="btn" onClick={() => { setCurrentPage(0); loadHosts(0)}}> Search</button>
                    </div>
                </div>
                <List list={hosts} href="host" headings={headings} loading={loading} onCheck={setChecks} />
                <div className="list-arrows">
                    {currentPage > 0 && (
                        <button className="btn btn-square btn-arrow" onClick={() => {
                            loadHosts(currentPage - 1);
                            setCurrentPage(c => c - 1);
                        }}>{'\u2039'}</button>
                    )}
                    {pages.map(p => (
                        <button key={p} className={"btn btn-squared" + (p == currentPage ? ' current-page' : '')} onClick={() => {
                            loadHosts(p);
                            setCurrentPage(p);
                        }}>{p + 1}</button>
                    ))}
                    {(currentPage + 1) * pageSize < totalRecords - 1 && (
                        <button className="btn btn-square btn-arrow" onClick={() => {
                            loadHosts(currentPage + 1);
                            setCurrentPage(c => c + 1);
                        }}>{'\u203A'}</button>
                    )}
                </div>
            </div>
        </main>
    )
}

export default HostList;